import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";

// Icon Imports
import { MdHome, MdPerson, MdLock, MdBusiness } from "react-icons/md";
import UserList from "views/admin/CRM/UserList";
import Employee from "views/admin/CRM/Employee";
import Adduser from "views/auth/AddUser";
import CreareEnquiry from "views/admin/CRM/CreareEnquiry";
import Airlines from "views/admin/CRM/Airlines";
import OneWay from "components/FlightWayRoute/OneWay";
import RoundTrip from "components/FlightWayRoute/RoundTrip";
import MultiCity from "components/FlightWayRoute/MultiCity";
import FlightWayRoute from "components/FlightWayRoute/FlightWayRoute";
import Departments from "views/admin/CRM/Departments";
import EnquirySource from "views/admin/CRM/EnquirySource";
import {
  FaCodeBranch,
  FaEnvelope,
  FaHotel,
  FaWhatsapp,
} from "react-icons/fa";
import EnquiryStatus from "views/admin/CRM/EnquiryStatus";
import Hotel from "views/admin/CRM/Hotel/Hotel";
import CreatedEnquiryList from "views/admin/CRM/CreatedEnquiryList";
import AssignEnquiryList from "views/admin/CRM/AssignEnquiryList";
import HotelList from "views/admin/CRM/Hotel/HotelList";
import SearchEnquiry from "views/admin/CRM/SearchEnquiry";
import Branch from "views/admin/CRM/Branch";
import EnquiryList from "views/admin/CRM/EnquiryList";
import FlightStatistics from "views/admin/CRM/FlightStatistics";
import HotelStatistics from "views/admin/CRM/HotelStatistics";
import HotelCreatedEnquiryList from "views/admin/CRM/Hotel/HotelCreatedEnquiryList";
import HotelAssignEnquiryList from "views/admin/CRM/Hotel/HotelAssignEnquiryList";
import HotelSearchEnquiry from "views/admin/CRM/Hotel/HotelSearchEnquiry";
import TransitionType from "views/admin/CRM/TransitionType";
import Suppliers from "views/admin/CRM/Suppliers";
import Banner from "views/admin/CRM/Banner";
import { RiMessage2Fill } from "react-icons/ri";
import OtherServce from "views/admin/CRM/Other/OtherServce";
import Instaenquiry from "views/admin/CRM/Instaenquiry";
import AllOtherServesList from "views/admin/CRM/Other/AllOtherServesList";
import AssignedOtherServesList from "views/admin/CRM/Other/AssignedOtherServesList";
import CreatedOtherServesList from "views/admin/CRM/Other/CreatedOtherServesList";
import SearchOtherServices from "views/admin/CRM/Other/SearchOtherServices";
import CreateNewInvoice from "views/admin/Invoice/CreateNewInvoice";
import SearchInvoice from "views/admin/Invoice/SearchInvoice";
import SuppliersPayment from "views/admin/Invoice/Tracking/SuppliersPayment";
import PaxPayment from "views/admin/Invoice/Tracking/PaxPayment";
import CommissionReceivables from "views/admin/Invoice/Tracking/CommissionReceivables";
import RefundFromSupplier from "views/admin/Invoice/Tracking/RefundFromSupplier";
import AgencySales from "views/admin/Invoice/Reports/AgencySales";
import EmployeeSales from "views/admin/Invoice/Reports/EmployeeSales";
import SupplierSales from "views/admin/Invoice/Reports/SupplierSales";
import AirlineSales from "views/admin/Invoice/Reports/AirlineSales";
import DestinationSales from "views/admin/Invoice/Reports/DestinationSales";
import CreateNewCustomer from "views/admin/Invoice/CreateNewCustomer";
import FeedbackList from "Pages/Home/Feedback/FeedbackList";
import CreditCardsInfo from "Pages/Home/CREDITCARDAUTHORIZATIONFORM/CreditCardsInfo";
import CreditCardAuthorizationForm from "Pages/Home/CREDITCARDAUTHORIZATIONFORM/Creditcardauthorizationform";
import OtherServiceStatics from "views/admin/CRM/Other/OtherServiceStatics";
import AirTicket from "views/admin/Invoice/Components/AirTicket";
import Insurance from "views/admin/Invoice/Components/Insurance";
import LandPackage from "views/admin/Invoice/Components/LandPackage";
import Cruise from "views/admin/Invoice/Components/Cruise";
import HotelForm from "views/admin/Invoice/Components/HotelForm";
import Misc from "views/admin/Invoice/Components/Misc";
import InvoiceList from "views/admin/Invoice/InvoiceList";
import Airport from "views/admin/CRM/Airport";
import { IoLogoWhatsapp } from "react-icons/io";
import CustomerNumberList from "components/twilio/whatsapp/CustomerNumberList";
import AllPackagesEnquiryList from "views/admin/CRM/packages/AllPackagesEnquiryList";
import CreatedPackagesEnquiryList from "views/admin/CRM/packages/CreatedPackagesEnquiryList";
import AssignPackagesEnquiryList from "views/admin/CRM/packages/AssignPackagesEnquiryList";
import SearchPackages from "views/admin/CRM/packages/SearchPackages";
import InvoiceStatics from "views/admin/Invoice/InvoiceStatics/InvoiceStatics";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <MainDashboard />,
    show: true,
  },
  {
    name: "Flight Statistics",
    layout: "/admin",
    path: "flight-statistics",
    component: <FlightStatistics />,
    show: false,
  },
  {
    name: "Hotel Statistics",
    layout: "/admin",
    path: "hotel-statistics",
    component: <HotelStatistics />,
    show: false,
  },
  {
    name: "Other Service Statistics",
    layout: "/admin",
    path: "other-service-statistics",
    component: <OtherServiceStatics />,
    show: false,
  },
  // {
  //   name: "NFT Marketplace",
  //   layout: "/admin",
  //   path: "nft-marketplace",
  //   icon: (
  //     <MdOutlineShoppingCart className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
  //   ),
  //   component: <NFTMarketplace />,
  //   secondary: true,
  //   show: true,
  // },
  // {
  //   name: "Data Tables",
  //   layout: "/admin",
  //   icon: <MdBarChart className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
  //   path: "data-tables",
  //   component: <DataTables />,
  //   show: true,
  // },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <Profile />,
    show: true,
  },
  {
    name: "WhatsApp",
    layout: "/admin",
    path: "whatsApp",
    icon: (
      <IoLogoWhatsapp className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <CustomerNumberList />,
    show: true,
  },
  // {
  //   name: "Sign In",
  //   layout: "/auth",
  //   path: "sign-in",
  //   icon: <MdLock className="text-gray-900 dark:text-[#09c8ff] h-6 w-6" />,
  //   component: <SignIn />,
  // },
  {
    name: "Add User",
    layout: "/auth",
    path: "add-user",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <Adduser />,
    show: false,
  },
  {
    name: "User List",
    layout: "/admin",
    path: "user-list",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <UserList />,
    show: false,
  },
  {
    name: "Employee List",
    layout: "/admin",
    path: "employee-list",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <Employee />,
    show: false,
  },
  {
    name: "Create Enquiry",
    layout: "/admin",
    path: "create-enquiry",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <CreareEnquiry />,
    show: false,
    children: [
      {
        name: "Flight",
        path: "flight",
        component: <FlightWayRoute />,
        show: true,
        InnerChildren: [
          {
            name: "OneWay",
            path: "oneWay",
            component: <OneWay />,
            show: true,
          },
          {
            name: "RoundTrip",
            path: "round-trip",
            component: <RoundTrip />,
            show: true,
          },
          {
            name: "MultiCity",
            path: "multi-city",
            component: <MultiCity />,
            show: true,
          },
        ],
      },
      {
        name: "Hotel",
        path: "Hotel",
        component: <Hotel />,
        show: true,
      },

      {
        name: "Other Service",
        path: "Other-service",
        component: <OtherServce />,
        show: true,
      },
    ],
  },
  {
    name: "Enquiry List",
    layout: "/admin",
    path: "enquiry-list",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <EnquiryList />,
    show: false,
  },

  {
    name: "Created Enquiry List",
    layout: "/admin",
    path: "created-enquiry-list",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <CreatedEnquiryList />,
    show: false,
  },
  {
    name: "Assigned Enquiry List",
    layout: "/admin",
    path: "assigned-enquiry-list",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <AssignEnquiryList />,
    show: false,
  },
  {
    name: "Search Flight Enquiry",
    layout: "/admin",
    path: "search-enquiry",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <SearchEnquiry />,
    show: false,
  },
  {
    name: "Create New Invoice",
    layout: "/admin",
    path: "create-new-invoice",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <CreateNewInvoice />,
    show: false,
    children: [
      {
        name: "Air Ticket",
        path: "air-ticket",
        component: <AirTicket />,
        show: true,
      },
      {
        name: "Insurance",
        path: "insurance",
        component: <Insurance />,
        show: true,
      },
      {
        name: "Land Package",
        path: "land-package",
        component: <LandPackage />,
        show: true,
      },
      {
        name: "Cruise",
        path: "cruise",
        component: <Cruise />,
        show: true,
      },
      {
        name: "Hotel",
        path: "hotel",
        component: <HotelForm />,
        show: true,
      },
      {
        name: "Misc",
        path: "misc",
        component: <Misc />,
        show: true,
      },
    ],
  },

  {
    name: "Air Ticket",
    layout: "/admin",
    path: "create-new-invoice/air-ticket",
    component: <AirTicket />,
    show: false,
  },
  {
    name: "Insurance",
    layout: "/admin",
    path: "create-new-invoice/insurance",
    component: <Insurance />,
    show: false,
  },
  {
    name: "Land Package",
    layout: "/admin",
    path: "create-new-invoice/land-package",
    component: <LandPackage />,
    show: false,
  },
  {
    name: "Cruise",
    layout: "/admin",
    path: "create-new-invoice/cruise",
    component: <Cruise />,
    show: false,
  },
  {
    name: "Hotel",
    layout: "/admin",
    path: "create-new-invoice/hotel",
    component: <HotelForm />,
    show: false,
  },
  {
    name: "Misc",
    layout: "/admin",
    path: "create-new-invoice/misc",
    component: <Misc />,
    show: false,
  },
  {
    name: "Invoice List",
    layout: "/admin",
    path: "total-invoice",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <InvoiceList />,
    show: false,
  },
  {
    name: "Search Invoices",
    layout: "/admin",
    path: "search-invoices",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <SearchInvoice />,
    show: false,
  },
  {
    name: "Supplier Payment",
    layout: "/admin",
    path: "supplier-payment",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <SuppliersPayment />,
    show: false,
  },
  {
    name: "Pax Payment",
    layout: "/admin",
    path: "pax-payment",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <PaxPayment />,
    show: false,
  },
  {
    name: "Commission Receivables",
    layout: "/admin",
    path: "commission-receivables",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <CommissionReceivables />,
    show: false,
  },
  {
    name: "Refund From Supplier", // Updated name for the component
    layout: "/admin",
    path: "refund-from-supplier",
    icon: <FaEnvelope className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <RefundFromSupplier />,
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Agency Sales Report", // Updated name for the component
    layout: "/admin",
    path: "agency-sales",
    icon: <FaEnvelope className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <AgencySales />,
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Employee Sales", // Updated name for the component
    layout: "/admin",
    path: "employee-sales",
    icon: <FaEnvelope className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <EmployeeSales />,
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Supplier Sales", // Updated name for the component
    layout: "/admin",
    path: "supplier-sales", // Updated path for the Enquiry Source component
    icon: <FaEnvelope className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <SupplierSales />, // Updated to use EnquirySource component
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Airline Sales", // Updated name for the component
    layout: "/admin",
    path: "airline-sales", // Updated path for the Enquiry Source component
    icon: <FaEnvelope className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <AirlineSales />, // Updated to use EnquirySource component
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Destination Sales", // Updated name for the component
    layout: "/admin",
    path: "destination-sales", // Updated path for the Enquiry Source component
    icon: <FaEnvelope className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <DestinationSales />, // Updated to use EnquirySource component
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Enquiry Source", // Updated name for the component
    layout: "/admin",
    path: "enquiry-source", // Updated path for the Enquiry Source component
    icon: <FaEnvelope className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <EnquirySource />, // Updated to use EnquirySource component
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Enquiry Status", // Updated name for the component
    layout: "/admin",
    path: "enquiry-status", // Updated path for the Enquiry Source component
    icon: <FaEnvelope className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <EnquiryStatus />, // Updated to use EnquirySource component
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Transaction Type", // Updated name for the component
    layout: "/admin",
    path: "transaction-type", // Updated path for the Enquiry Source component
    icon: <FaEnvelope className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <TransitionType />, // Updated to use EnquirySource component
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Hotel Enquiry's", // Updated name for the component
    layout: "/admin",
    path: "hotel-enquirys", // Updated path for the Enquiry Source component
    icon: <FaHotel className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <HotelList />, // Updated to use EnquirySource component
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Hotel Created Enquirys",
    layout: "/admin",
    path: "hotel-created-enquirys",
    icon: (
      <FaCodeBranch className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <HotelCreatedEnquiryList />,
    show: false,
  },
  {
    name: "Hotel Assigned Enquiry",
    layout: "/admin",
    path: "hotel-assigned-enquirys",
    icon: (
      <FaCodeBranch className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <HotelAssignEnquiryList />,
    show: false,
  },
  {
    name: "Search Hotel Enquiry",
    layout: "/admin",
    path: "search-hotel-enquirys",
    icon: (
      <FaCodeBranch className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <HotelSearchEnquiry />,
    show: false,
  },
  // packages
  {
    name: "Packages Enquiry's", // Updated name for the component
    layout: "/admin",
    path: "package-enquirys", // Updated path for the Enquiry Source component
    icon: <FaHotel className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />, // Icon remains the same or can be customized
    component: <AllPackagesEnquiryList />, // Updated to use EnquirySource component
    show: false, // Set to true to make it visible in the navigation
  },
  {
    name: "Package Created Enquirys",
    layout: "/admin",
    path: "package-created-enquirys",
    icon: (
      <FaCodeBranch className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <CreatedPackagesEnquiryList />,
    show: false,
  },
  {
    name: "Package Assigned Enquiry",
    layout: "/admin",
    path: "package-assigned-enquirys",
    icon: (
      <FaCodeBranch className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <AssignPackagesEnquiryList />,
    show: false,
  },
  {
    name: "Search package Enquiry",
    layout: "/admin",
    path: "search-package-enquirys",
    icon: (
      <FaCodeBranch className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <SearchPackages />,
    show: false,
  },

  {
    name: "Air Lines",
    layout: "/admin",
    path: "air-lines",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <Airlines />,
    show: false,
  },
  {
    name: "Airport",
    layout: "/admin",
    path: "airport",
    icon: <MdLock className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <Airport />,
    show: false,
  },
  {
    name: "Department",
    layout: "/admin",
    path: "department",
    icon: <MdBusiness className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <Departments />,
    show: false,
  },
  {
    name: "Branch",
    layout: "/admin",
    path: "branch",
    icon: (
      <FaCodeBranch className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <Branch />,
    show: false,
  },
  {
    name: "Suppliers",
    layout: "/admin",
    path: "suppliers",
    icon: (
      <FaCodeBranch className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <Suppliers />,
    show: false,
  },
  {
    name: "Bulk Messages",
    layout: "/admin",
    path: "send-msg",
    icon: <FaWhatsapp className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <Banner />,
    show: true,
  },
  {
    name: "Create New Customer",
    layout: "/admin",
    path: "create-new-customer",
    icon: <FaWhatsapp className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
    component: <CreateNewCustomer />,
    show: false,
  },
  // {
  //   name: "Attendance",
  //   layout: "/admin",
  //   path: "attendance",
  //   icon: <FaCodeBranch className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />,
  //   component: <Attendance />,
  //   show: true,
  // },
  {
    name: "Instagram Enquiry",
    layout: "/admin",
    path: "instagram-enquirys",
    icon: (
      <RiMessage2Fill className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <Instaenquiry />,
    show: false,
  },
  {
    name: "User feedback",
    layout: "/admin",
    path: "user-feedback",
    icon: (
      <RiMessage2Fill className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <FeedbackList />,
    show: false,
  },
  {
    name: "Credit Cards Authorization",
    layout: "/admin",
    path: "/credit-card-authorization",
    icon: (
      <RiMessage2Fill className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <CreditCardAuthorizationForm />,
    show: false,
  },
  {
    name: "Credit Cards Information",
    layout: "/admin",
    path: "credit-cards-information",
    icon: (
      <RiMessage2Fill className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <CreditCardsInfo />,
    show: false,
  },
  {
    name: "Other Enquiry",
    layout: "/admin",
    path: "other-enquirys",
    icon: (
      <RiMessage2Fill className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <AllOtherServesList />,
    show: false,
  },
  {
    name: "Assigned Enquiry",
    layout: "/admin",
    path: "other-assigned-enquirys",
    icon: (
      <RiMessage2Fill className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <AssignedOtherServesList />,
    show: false,
  },
  {
    name: "Created Enquiry",
    layout: "/admin",
    path: "other-created-enquirys",
    icon: (
      <RiMessage2Fill className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <CreatedOtherServesList />,
    show: false,
  },
  {
    name: "Search Others Service",
    layout: "/admin",
    path: "search-other-enquirys",
    icon: (
      <RiMessage2Fill className="h-6 w-6 text-gray-900 dark:text-[#09c8ff]" />
    ),
    component: <SearchOtherServices />,
    show: false,
  },
  {
    name: "Invoice Statistics",
    layout: "/admin",
    path: "invoice-statistics",
    component: <InvoiceStatics />,
    show: false,
  },
];
export default routes;
